// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"735d4b58","406":"0a22127d","470":"979c832d","616":"4d13a594","657":"a3860be0","724":"60eff286","829":"a20b4b24"}[chunkId] + ".chunk.js";
};